export const partsFilterSetup = [
	{ label: "Search Part", value: "search", type: "text_change" },
];
